export default __webpack_public_path__ + "static/media/exclamation-triangle_red.a3b0c81c.svg";